<template>
    <div class="ReLeadMessageButton">
        <!-- <div class="d-flex" v-if="typeLink == true">
            <span class="mr-2" @click="callAgent">{{ this.phone }}</span>
        </div> -->
        <!-- <base-button @click="callAgent" type="success" :class="[{'no-border': borderStyle=='noborder'}]" class="btn btn-icon mt-0" simple><i class="tim-ic ic-phone pt-1"></i></base-button> -->
       
        <!-- <base-button @click="openMessenger" type="success" :class="[{'no-border': borderStyle=='noborder'}]" class="btn btn-icon" simple><i class="tim-icons icon-send text-success"></i></base-button> -->
        <div class="message-container">
            <div class="w-100 mr-2">
                <textarea 
                    class="form-control w-100"
                    :placeholder="placeholder"
                    style="line-height: 1;"
                    v-model="bufferValue"
                    @change="onChange"
                >	
                </textarea>	
                <p class="text-success" v-if="isShown"> {{ this.lastMessage }}</p>   
            </div>
            
            <base-button :disabled="!canSend" @click="sendMessage" type="success" :class="[{'no-border': borderStyle=='noborder'}]" class="btn btn-icon" simple><i class="tim-icons icon-send text-success"></i></base-button>
            <div v-if="!canSend" class="d-flex w-100 text-warning">Телеграм или макс ответственного {{ staff_code }} не подключен!</div>
            <!-- <div v-else>
                <span v-if="staff_data.telegram_id>0 && staff_data.telegram_active==1">Телеграм</span>
                <span v-if="staff_data.max_id>0 && staff_data.max_active==1">Макс</span>
            </div> -->
           
        </div>   
        <template v-if="isShown">
            <div class="d-flex w-100 text-success">Сообщение отправлено!</div>
        </template>
    </div>
</template>
<script>
import { Button } from 'element-ui';
export default {
    name: 'ReLeadMessageButton',
    components: {
        [Button.name]: Button,
    },
    props: {
        staff_name:{
            type: String,
        },
        staff_code:{
            type: [String, Number],
        },
        contact_value:{
            type: [String, Number],
        },
        obj_type:{
            type: String,
        },
        obj_id:{
            type: [String, Number],
        },
        obj_name:{
            type: String,
        },
        borderStyle:{
            type: String,
            default:''
        },
        placeholder:{
            type: String,
            default:'Сообщение ответственному'
        },
        client_id:{
            type: [String, Number],
        },
        messageSent:{
            type: String,
            default:''
        },
        bShowSendBtn:{
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            bIsShown: false,
            //messageSent: '',
            isShown:false,
            bufferValue: null,
            lastMessage: '',
            staff_data: false,
        }
    },
    watch: {
        staff_code(val){
            this.get_staff_extra_data();
        },
        
        messageSent(val){
            this.bufferValue = this.$GVO.unlinkObject(val);
        },
        bufferValue(val){
            this.bufferValue = val;
            this.$emit("change", val == this.messageSent?'':val);
        },
        
    },
    computed:{
        canSend(){
            if(!this.staff_data) return false;
            if(this.staff_data.telegram_id>0 && this.staff_data.telegram_active==1) return true;
            if(this.staff_data.max_id>0 && this.staff_data.max_active==1) return true;
            return false;
        }
    },
    methods: {
        // openMessenger(){
        //     this.bIsShown = !this.bIsShown;
        // },
        get_staff_extra_data(){
            // метод создаётся позже
                this.$GVO.ApiCall('staff.GET_STAFF_EXTRA_DATA',{flt:{'code':this.staff_code}},{useCache: true})
                .then((objApi) => {
                    if(objApi.success === true){
                        this.staff_data = objApi.data[0];
                    }
                }).catch(errorObjApi => {console.error(errorObjApi);});            
        },
        sendMessage(){
            if(this.bufferValue == '' || this.bufferValue == this.lastMessage) return false;
            let text = this.bufferValue;
            // SEND_ALL_NOTICE
            this.$GVO.ApiCall('notice.SEND_ALL_NOTICE',{'iData':{
					"obj_type":this.obj_type,
					"obj_id":this.obj_id,
			        "obj_name":this.obj_name,
			        // "staff_name":this.staff_name,
			        "agent_id":this.staff_code,
					// "contact_type":'telegram',
			        // "contact_value":this.contact_value, // это id телеги?
			        "message":`❕Уведомление от контакт-центра

📞 `+text,
					'notice_type' : 4096,
                    'client_id': this.client_id,
			    }})
            .then((objApi) => {
                this.bufferValue = this.messageSent;
                if(objApi.success === true){
                    this.lastMessage = text;
                    this.isShown=true;
                }else{this.isShown=false;}
            }).catch(errorObjApi => {console.error(errorObjApi);});

            // this.$emit("messageSent", this.messageSent);
        },
        onChange(){
            this.$emit('change', this.bufferValue == this.messageSent?'':this.bufferValue);
        }
    },
    created(){
        // eventEmitter.$on('OnSendLeadMessage', this.sendMessage);
        this.bufferValue = this.messageSent
        this.get_staff_extra_data();
    },
	beforeDestroy() {
		// Отписываемся от события
        // eventEmitter.$off('OnSendLeadMessage', this.sendMessage);
	},
}
</script>
<style scoped>
.ReLeadMessageButton {display: flex; flex-direction: column; width: 100%;}
.message-container {display: inline-flex; width: 100%;}

</style>